import { OFFER_DIALOG_USE_PROCESSING_TIME } from 'reduxStore/actionsConst';

import { OfferDialogUseProcessingTimeAction } from './types';

export const setUseProcessingTime = (value: boolean): OfferDialogUseProcessingTimeAction => ({
  type: OFFER_DIALOG_USE_PROCESSING_TIME,
  payload: value,
});
